import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmModal } from '@tanium/react-confirm-modal';
import { AsyncStatus } from '../../hooks/useAsync';

interface CreateAccountModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  createTenantExecute: () => Promise<void>;
  createTenantStatus: AsyncStatus;
}

export const CreateAccountModal: React.FC<CreateAccountModalProps> = ({
  isOpen,
  onRequestClose,
  createTenantExecute,
  createTenantStatus,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (createTenantStatus === AsyncStatus.Pending) {
      onRequestClose();
    } else if (createTenantStatus === AsyncStatus.Failure) {
      onRequestClose();
    }
  }, [createTenantStatus, onRequestClose]);

  return (
    <ConfirmModal
      isOpen={isOpen}
      header={t('Create Account Without Linked Instances')}
      onConfirm={createTenantExecute}
      onCancel={onRequestClose}
      confirmLabel={t('Create Account')}
      cancelLabel={t('Cancel')}
      isConfirmDisabled={createTenantStatus === AsyncStatus.Pending}
    >
      <>
        {t(
          'You are about to create an account that is not connected to any cloud or hosted instances. This setup is primarily intended for customers using our on-premises solution.'
        )}
      </>
      <br />
      <br />
      <>{t('Are you sure you want to continue?')}</>
    </ConfirmModal>
  );
};
